// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"9bd7cafd","282":"5df83df9","453":"584e3e5b","487":"c8f4c0d3","540":"3bfc3d78","555":"363d2fde","990":"6f817853","996":"acb0751b"}[chunkId] + ".chunk.js";
};